import React from 'react';
import logoPrefeitura from 'assets/img/logo-prefeitura.svg';
import SistemasSefaz from './SistemasSefaz/index';
import PerfilSefaz from './SefazPerfil/index';
import * as S from './styles';
import { altLogoIconeSefaz } from 'utils/acessibilidade';

export const HeaderSefaz = () => {
  return (
    <S.Header>
      <S.Container>
        <S.Home src={logoPrefeitura} alt={altLogoIconeSefaz} data-testid="LogoInicioSefazHeader" />
        <S.Texto>PREFEITURA MUNICIPAL DO SALVADOR - SECRETARIA DA FAZENDA</S.Texto>
        <S.IconSefaz>
          <SistemasSefaz />
          <PerfilSefaz />
        </S.IconSefaz>
      </S.Container>
    </S.Header>
  );
};

export default HeaderSefaz;
